import { CianNewbuildingChatButton, CianNewbuildingChatButtonContext } from '@cian/newbuilding-chat-component';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useBuilderChatButtonContextValue, useBuilderChatOpenHandler } from 'shared/hooks/builderChats';

export const NewbuildingHeaderChatButtonContainer: React.FC = () => {
  const chatButtonContextValue = useBuilderChatButtonContextValue();
  const openChat = useBuilderChatOpenHandler({ placeType: 'Open_jk_head_block' });

  return (
    <CianNewbuildingChatButtonContext.Provider value={chatButtonContextValue}>
      <CianNewbuildingChatButton
        onChatOpen={openChat}
        size="M"
        theme="stroke_primary"
        type="button"
        beforeIcon={<IconCommunicationMessage16 color="icon-main-default" />}
      >
        Написать
      </CianNewbuildingChatButton>
    </CianNewbuildingChatButtonContext.Provider>
  );
};
